import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IPKCEGetAuthorizationCodeParams {
  codeChallenge: string;
  codeChallengeMethod: string;
}

export interface IPKCEGetAuthorizationCodeResult extends IResult {
  authorizationCode: string;
}

export class PKCEGetAuthorizationCodeRequest extends Request<IPKCEGetAuthorizationCodeParams, IPKCEGetAuthorizationCodeResult> {
  constructor(params: IPKCEGetAuthorizationCodeParams) {
    super('pkceGetAuthorizationCode', params);
  }
}
